<template>
    <div class="input input--textarea" v-bind:class="{'input--invalid': error, 'focused': focused, 'filled': value}">
        <label v-if="label" :for="inputId">{{ label }}</label>
        <textarea ref="input" :value.trim="value" :name="name" :placeholder="placeholder" @input="onUpdate()"
                  @blur="onBlur" @focus="onFocus" :disabled="disabled" :id="inputId" :class="lengthType"/>
        <input-error v-if="v" :v="v" :name="name" @o3-error="error = $event"></input-error>
    </div>
</template>

<script>
import InputMixin from './mixin';

export default {
    mixins: [InputMixin]
}
</script>
